import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import axios from "../../../../../axios";
import "../../SChedule/Schedule_Q_List/ScheduleQListHW.css";
import ImgTypeScheduleQuestion from "./ScheduleQuestionType/ImgType/ImgTypeScheduleQuestion";
import McqTypeScheduleQuestion from "./ScheduleQuestionType/McqType/McqTypeScheduleQuestion";

export default function ScheduleQListHW() {
  const { state } = useLocation();
  const [assessment, setAssessment] = useState();
  //Added this state by kuldeep
  useEffect(() => {
    const getAssessment = async () => {
      try {
        let res = await axios.get(`/api/v1/homework/get/${state.homework_id}`);
        res && setAssessment(res.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    getAssessment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {assessment ? (
        <>
          <div className="d-flex align-items-center  ">
            <Link
              to={
                localStorage.getItem("Header") === "Content Management"
                  ? "/contentMangment"
                  : "/PublishedHomework"
              }
              className="link"
            >
              <img src="/images/Back Arrow.svg" alt=""></img>
            </Link>
            <Link
              to={
                localStorage.getItem("Header") === "Content Management"
                  ? "/contentMangment"
                  : "/PublishedHomework"
              }
              className="link"
            >
              <span className="published_hw_file_path1">
                &nbsp; Homework /&nbsp;
              </span>
            </Link>
            <span className="published_hw_file_path2">Homework Detail</span>
          </div>
          <div className="mt-2 ms-1 published_tittle_heading">
            {assessment?.name}
          </div>
          <div className="me-5 d-flex align-items-center justify-content-between">
            <div className="mt-1 ms-1  d-flex align-items-center ">
              <span className="me-2">{assessment?.subject_id?.name}</span>
              <span className=" open_ststus_hw ">Scheduled</span>
            </div>
            <div className="d-flex gap-3">
              {/* ///////////////////// */}:{/* //////////// */}
              <NavLink
                to={`/EditScheduleHw`}
                state={{ homework_id: assessment?.id }}
              >
                <button className="hw_delet_button px-4">Edit</button>
              </NavLink>
            </div>
          </div>

          {assessment?.questions?.length >= 0 &&
            assessment?.questions?.map((question, index) => {
              if (
                question.type.name === "MCQ Type" ||
                !question.type.is_manually_graded
              ) {
                return (
                  <McqTypeScheduleQuestion
                    key={index}
                    questionNumber={index + 1}
                    question={question}
                  />
                );
              } else {
                return (
                  <ImgTypeScheduleQuestion
                    key={index}
                    questionNumber={index + 1}
                    question={question}
                  />
                );
              }
            })}
        </>
      ) : (
        <img className="qList_loader" src="/gif/LoaderDot.gif" alt="" />
      )}
    </>
  );
}
